module.exports = __webpack_public_path__ + "img/history-bg-2.6acfd414.png";